import { render, staticRenderFns } from "./OsCloseButton.vue?vue&type=template&id=0ed53c1b&scoped=true"
import script from "./OsCloseButton.vue?vue&type=script&lang=ts"
export * from "./OsCloseButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed53c1b",
  null
  
)

export default component.exports